export default __webpack_public_path__ + "svg/CompaniesLogos/logo_iristrace.svg?8b85a658";